module.exports = __webpack_public_path__ + "static/kopi-19-7e39c5b873693ce54702baaa39e5dc58.png";